(function() {	
	"use strict";

	function CityConjugationFilter() {
		var cities = {
			"Akaa": { own: "Akaan", in: "Akaalla" },
			"Alajärvi": { own: "Alajärven", in: "Alajärvellä" },
			"Alavieska": { own: "Alavieskan", in: "Alavieskassa" },
			"Alavus": { own: "Alavuden", in: "Alavudella" },
			"Asikkala": { own: "Asikkalan", in: "Asikkalassa" },
			"Askola": { own: "Askolan", in: "Askolassa" },
			"Aura": { own: "Auran", in: "Aurassa" },
			"Brändö": { own: "Brändön", in: "Brändössa" },
			"Eckerö": { own: "Eckerön", in: "Eckerössä" },
			"Enonkoski": { own: "Enonkosken", in: "Enonkoskella" },
			"Enontekiö": { own: "Enontekiön", in: "Enontekiöllä" },
			"Espoo": { own: "Espoon", in: "Espoossa" },
			"Eura": { own: "Euran", in: "Eurassa" },
			"Eurajoki": { own: "Eurajoen", in: "Eurajoella" },
			"Evijärvi": { own: "Evijärven", in: "Evijärvellä" },
			"Finström": { own: "Finströmin", in: "Finströmissä" },
			"Forssa": { own: "Forssan", in: "Forssassa" },
			"Föglö": { own: "Föglön", in: "Föglössa" },
			"Geta": { own: "Getan", in: "Getassa" },
			"Haapajärvi": { own: "Haapajärven", in: "Haapajärvellä" },
			"Haapavesi": { own: "Haapaveden", in: "Haapavedellä" },
			"Hailuoto": { own: "Hailuodon", in: "Hailuodossa" },
			"Halsua": { own: "Halsuan", in: "Halsualla" },
			"Hamina": { own: "Haminan", in: "Haminassa" },
			"Hammarland": { own: "Hammarlandin", in: "Hammarlandissa" },
			"Hankasalmi": { own: "Hankasalmen", in: "Hankasalmella" },
			"Hanko": { own: "Hangon", in: "Hangossa" },
			"Harjavalta": { own: "Harjavallan", in: "Harjavallassa" },
			"Hartola": { own: "Hartolan", in: "Hartolassa" },
			"Hattula": { own: "Hattulan", in: "Hattulassa" },
			"Hausjärvi": { own: "Hausjärven", in: "Hausjärvellä" },
			"Heinola": { own: "Heinolan", in: "Heinolassa" },
			"Heinävesi": { own: "Heinäveden", in: "Heinävedellä" },
			"Helsinki": { own: "Helsingin", in: "Helsingissä" },
			"Hirvensalmi": { own: "Hirvensalmen", in: "Hirvensalmella" },
			"Hollola": { own: "Hollolan", in: "Hollolassa" },
			"Honkajoki": { own: "Honkajoen", in: "Honkajoella" },
			"Huittinen": { own: "Huittisten", in: "Huittisilla" },
			"Humppila": { own: "Humppilan", in: "Humppilassa" },
			"Hyrynsalmi": { own: "Hyrynsalmen", in: "Hyrynsalmella" },
			"Hyvinkää": { own: "Hyvinkään", in: "Hyvinkäällä" },
			"Hämeenkyrö": { own: "Hämeenkyrön", in: "Hämeenkyrössä" },
			"Hämeenlinna": { own: "Hämeenlinnan", in: "Hämeenlinnassa" },
			"Ii": { own: "Iin", in: "Iissä" },
			"Iisalmi": { own: "Iisalmen", in: "Iisalmella" },
			"Iitti": { own: "Iitin", in: "Iitissä" },
			"Ikaalinen": { own: "Ikaalisten", in: "Ikaalisissa" },
			"Ilmajoki": { own: "Ilmajoen", in: "Ilmajoella" },
			"Ilomantsi": { own: "Ilomantsin", in: "Ilomantsissa" },
			"Imatra": { own: "Imatran", in: "Imatralla" },
			"Inari": { own: "Inarin", in: "Inarissa" },
			"Inkoo": { own: "Inkoon", in: "Inkoossa" },
			"Isojoki": { own: "Isojoen", in: "Isojoella" },
			"Isokyrö": { own: "Isokyrön", in: "Isokyrössä" },
			"Janakkala": { own: "Janakkalan", in: "Janakkalassa" },
			"Joensuu": { own: "Joensuun", in: "Joensuussa" },
			"Jokioinen": { own: "Jokioisten", in: "Jokioisilla" },
			"Jomala": { own: "Jomalan", in: "Jomalassa" },
			"Joroinen": { own: "Joroisten", in: "Joroisilla" },
			"Joutsa": { own: "Joutsan", in: "Joutsassa" },
			"Juuka": { own: "Juukan", in: "Juukassa" },
			"Juupajoki": { own: "Juupajoen", in: "Juupajoella" },
			"Juva": { own: "Juvan", in: "Juvalla" },
			"Jyväskylä": { own: "Jyväskylän", in: "Jyväskylässä" },
			"Jämijärvi": { own: "Jämijärven", in: "Jämijärvellä" },
			"Jämsä": { own: "Jämsän", in: "Jämsässä" },
			"Järvenpää": { own: "Järvenpään", in: "Järvenpäässä" },
			"Kaarina": { own: "Kaarinan", in: "Kaarinassa" },
			"Kaavi": { own: "Kaavin", in: "Kaavissa" },
			"Kajaani": { own: "Kajaanin", in: "Kajaanissa" },
			"Kalajoki": { own: "Kalajoen", in: "Kalajoella" },
			"Kangasala": { own: "Kangasalan", in: "Kangasalla" },
			"Kangasniemi": { own: "Kangasniemen", in: "Kangasniemillä" },
			"Kankaanpää": { own: "Kankaanpään", in: "Kankaanpäässä" },
			"Kannonkoski": { own: "Kannonkosken", in: "Kannonkoskella" },
			"Kannus": { own: "Kannuksen", in: "Kannuksella" },
			"Karijoki": { own: "Karijoen", in: "Karijoella" },
			"Karkkila": { own: "Karkkilan", in: "Karkkilassa" },
			"Karstula": { own: "Karstulan", in: "Karstulassa" },
			"Karvia": { own: "Karvian", in: "Karvialla" },
			"Kauhajoki": { own: "Kauhajoen", in: "Kauhajoella" },
			"Kauhava": { own: "Kauhavan", in: "Kauhavalla" },
			"Kauniainen": { own: "Kauniaisten", in: "Kauniaisissa" },
			"Kaustinen": { own: "Kaustisen", in: "Kaustisilla" },
			"Keitele": { own: "Keiteleen", in: "Keiteleessä" },
			"Kemi": { own: "Kemin", in: "Kemissä" },
			"Kemijärvi": { own: "Kemijärven", in: "Kemijärvellä" },
			"Keminmaa": { own: "Keminmaan", in: "Keminmaalla" },
			"Kemiönsaari": { own: "Kemiönsaaren", in: "Kemiönsaaressa" },
			"Kempele": { own: "Kempeleen", in: "Kempeleellä" },
			"Kerava": { own: "Keravan", in: "Keravalla" },
			"Keuruu": { own: "Keuruun", in: "Keuruulla" },
			"Kihniö": { own: "Kihniön", in: "Kihniössä" },
			"Kinnula": { own: "Kinnulan", in: "Kinnulassa" },
			"Kirkkonummi": { own: "Kirkkonummen", in: "Kirkkonummella" },
			"Kitee": { own: "Kiteen", in: "Kiteellä" },
			"Kittilä": { own: "Kittilän", in: "Kittilässä" },
			"Kiuruvesi": { own: "Kiuruveden", in: "Kiuruvedellä" },
			"Kivijärvi": { own: "Kivijärven", in: "Kivijärvellä" },
			"Kokemäki": { own: "Kokemäen", in: "Kokemäellä" },
			"Kokkola": { own: "Kokkolan", in: "Kokkolassa" },
			"Kolari": { own: "Kolarin", in: "Kolarissa" },
			"Konnevesi": { own: "Konneveden", in: "Konnevedellä" },
			"Kontiolahti": { own: "Kontiolahden", in: "Kontiolahdella" },
			"Korsnäs": { own: "Korsnäsin", in: "Korsnäsissä" },
			"Koski TL": { own: "Koski TL:n", in: "Koski TL:ssä" },
			"Kotka": { own: "Kotkan", in: "Kotkassa" },
			"Kouvola": { own: "Kouvolan", in: "Kouvolassa" },
			"Kristiinankaupunki": { own: "Kristiinankaupungin", in: "Kristiinankaupungissa" },
			"Kruunupyy": { own: "Kruunupyyn", in: "Kruunupyyssä" },
			"Kuhmo": { own: "Kuhmon", in: "Kuhmossa" },
			"Kuhmoinen": { own: "Kuhmoisten", in: "Kuhmoisissa" },
			"Kumlinge": { own: "Kumlingen", in: "Kumlingessa" },
			"Kuopio": { own: "Kuopion", in: "Kuopiossa" },
			"Kuortane": { own: "Kuortaneen", in: "Kuortaneella" },
			"Kurikka": { own: "Kurikan", in: "Kurikassa" },
			"Kustavi": { own: "Kustavin", in: "Kustavissa" },
			"Kuusamo": { own: "Kuusamon", in: "Kuusamossa" },
			"Kyyjärvi": { own: "Kyyjärven", in: "Kyyjärvellä" },
			"Kärkölä": { own: "Kärkölän", in: "Kärkölässä" },
			"Kärsämäki": { own: "Kärsämäen", in: "Kärsämäellä" },
			"Kökar": { own: "Kökarin", in: "Kökarissa" },
			"Lahti": { own: "Lahden", in: "Lahdessa" },
			"Laihia": { own: "Laihian", in: "Laihialla" },
			"Laitila": { own: "Laitilan", in: "Laitilassa" },
			"Lapinjärvi": { own: "Lapinjärven", in: "Lapinjärvellä" },
			"Lapinlahti": { own: "Lapinlahden", in: "Lapinlahdella" },
			"Lappajärvi": { own: "Lappajärven", in: "Lappajärvellä" },
			"Lappeenranta": { own: "Lappeenrannan", in: "Lappeenrannassa" },
			"Lapua": { own: "Lapuan", in: "Laupualla" },
			"Laukaa": { own: "Laukaan", in: "Laukaalla" },
			"Lemi": { own: "Lemin", in: "Lemillä" },
			"Lemland": { own: "Lemlandin", in: "Lemlandissa" },
			"Lempäälä": { own: "Lempäälän", in: "Lempäälässä" },
			"Leppävirta": { own: "Leppävirran", in: "Leppävirralla" },
			"Lestijärvi": { own: "Lestijärven", in: "Lestijärvellä" },
			"Lieksa": { own: "Lieksan", in: "Lieksassa" },
			"Lieto": { own: "Liedon", in: "Liedossa" },
			"Liminka": { own: "Limingan", in: "Limingalla" },
			"Liperi": { own: "Liperin", in: "Liperissä" },
			"Lohja": { own: "Lohjan", in: "Lohjassa" },
			"Loimaa": { own: "Loimaan", in: "Loimaalla" },
			"Loppi": { own: "Lopen", in: "Lopella" },
			"Loviisa": { own: "Loviisan", in: "Loviisassa" },
			"Luhanka": { own: "Luhangan", in: "Luhangalla" },
			"Lumijoki": { own: "Lumijoen", in: "Lumijoella" },
			"Lumparland": { own: "Lumparlandin", in: "Lumparlandissa" },
			"Luoto": { own: "Luodon", in: "Luodossa" },
			"Luumäki": { own: "Luumäen", in: "Luumäellä" },
			"Maalahti": { own: "Maalahden", in: "Maalahdessa" },
			"Maarianhamina": { own: "Maarianhaminan", in: "Maarianhaminassa" },
			"Marttila": { own: "Marttilan", in: "Marttilassa" },
			"Masku": { own: "Maskun", in: "Maskussa" },
			"Merijärvi": { own: "Merijärven", in: "Merijärvellä" },
			"Merikarvia": { own: "Merikarvian", in: "Merikarvialla" },
			"Miehikkälä": { own: "Miehikkälän", in: "Miehikkälässä" },
			"Mikkeli": { own: "Mikkelin", in: "Mikkelissä" },
			"Muhos": { own: "Muhoksen", in: "Muhoksella" },
			"Multia": { own: "Multian", in: "Multiassa" },
			"Muonio": { own: "Muonion", in: "Muoniossa" },
			"Mustasaari": { own: "Mustasaaren", in: "Mustasaaressa" },
			"Muurame": { own: "Muuramen", in: "Muuramella" },
			"Mynämäki": { own: "Mynämäen", in: "Mynämäellä" },
			"Myrskylä": { own: "Myrskylän", in: "Myrskylässä" },
			"Mäntsälä": { own: "Mäntsälän", in: "Mäntsälässä" },
			"Mänttä": { own: "Mäntän", in: "Mäntässä" },
			"Mäntyharju": { own: "Mäntyharjun", in: "Mäntyharjussa" },
			"Naantali": { own: "Naantalin", in: "Naantalissa" },
			"Nakkila": { own: "Nakkilan", in: "Nakkilassa" },
			"Nivala": { own: "Nivalan", in: "Nivalassa" },
			"Nokia": { own: "Nokian", in: "Nokialla" },
			"Nousiainen": { own: "Nousiaisten", in: "Nousiaisilla" },
			"Nummela": { own: "Nummelan", in: "Nummelassa" },
			"Nurmes": { own: "Nurmeksen", in: "Nurmeksella" },
			"Nurmijärvi": { own: "Nurmijärven", in: "Nurmijärvellä" },
			"Närpiö": { own: "Närpiön", in: "Närpiössä" },
			"Orimattila": { own: "Orimattilan", in: "Orimattilassa" },
			"Oripää": { own: "Oripään", in: "Oripäässä" },
			"Orivesi": { own: "Oriveden", in: "Orivedellä" },
			"Oulainen": { own: "Oulaisten", in: "Oulaisilla" },
			"Oulu": { own: "Oulun", in: "Oulussa" },
			"Outokumpu": { own: "Outokummun", in: "Outokummussa" },
			"Padasjoki": { own: "Padasjoen", in: "Padasjoella" },
			"Paimio": { own: "Paimion", in: "Paimiossa" },
			"Paltamo": { own: "Paltamon", in: "Paltamossa" },
			"Parainen": { own: "Paraisten", in: "Paraisilla" },
			"Parikkala": { own: "Parikkalan", in: "Parikkalassa" },
			"Parkano": { own: "Parkanon", in: "Parkanossa" },
			"Pedersören kunta": { own: "Pedersören kunnan", in: "Pedersören kunnassa" },
			"Pelkosenniemi": { own: "Pelkosenniemen", in: "Pelkosenniemellä" },
			"Pello": { own: "Pellon", in: "Pellossa" },
			"Perho": { own: "Perhon", in: "Perhossa" },
			"Pertunmaa": { own: "Pertunmaan", in: "Pertunmaalla" },
			"Petäjävesi": { own: "Petäjäveden", in: "Petäjävedellä" },
			"Pieksämäki": { own: "Pieksämäen", in: "Pieksämäellä" },
			"Pielavesi": { own: "Pielaveden", in: "Pielavedellä" },
			"Pietarsaari": { own: "Pietarsaaren", in: "Pietarsaaressa" },
			"Pihtipudas": { own: "Pihtiputaan", in: "Pihtiputaalla" },
			"Pirkkala": { own: "Pirkkalan", in: "Pirkkalassa" },
			"Polvijärvi": { own: "Polvijärven", in: "Polvijärvellä" },
			"Pomarkku": { own: "Pomarkun", in: "Pomarkkussa" },
			"Pori": { own: "Porin", in: "Porissa" },
			"Pornainen": { own: "Pornaisten", in: "Pornaisissa" },
			"Porvoo": { own: "Porvoon", in: "Porvoossa" },
			"Posio": { own: "Posion", in: "Posiossa" },
			"Pudasjärvi": { own: "Pudasjärven", in: "Pudasjärvellä" },
			"Pukkila": { own: "Pukkilan", in: "Pukkilassa" },
			"Punkalaidun": { own: "Punkalaitumen", in: "Punkalaitumella" },
			"Puolanka": { own: "Puolangan", in: "Puolangassa" },
			"Puumala": { own: "Puumalan", in: "Puumalassa" },
			"Pyhtää": { own: "Pyhtään", in: "Pyhtäällä" },
			"Pyhäjoki": { own: "Pyhäjoen", in: "Pyhäjoella" },
			"Pyhäjärvi": { own: "Pyhäjärven", in: "Pyhäjärvellä" },
			"Pyhäntä": { own: "Pyhännän", in: "Pyhännällä" },
			"Pyhäranta": { own: "Pyhärannan", in: "Pyhärannalla" },
			"Pälkäne": { own: "Pälkäneen", in: "Pälkäneellä" },
			"Pöytyä": { own: "Pöytyän", in: "Pöytyällä" },
			"Raahe": { own: "Raahen", in: "Raahessa" },
			"Raasepori": { own: "Raaseporin", in: "Raaseporissa" },
			"Raisio": { own: "Raision", in: "Raisiossa" },
			"Rantasalmi": { own: "Rantasalmen", in: "Rantasalmella" },
			"Ranua": { own: "Ranuan", in: "Ranualla" },
			"Rauma": { own: "Rauman", in: "Raumalla" },
			"Rautalampi": { own: "Rautalammin", in: "Rautalammella" },
			"Rautavaara": { own: "Rautavaaran", in: "Rautavaarassa" },
			"Rautjärvi": { own: "Rautjärven", in: "Rautjärvellä" },
			"Reisjärvi": { own: "Reisjärven", in: "Reisjärvellä" },
			"Riihimäki": { own: "Riihimäen", in: "Riihimäellä" },
			"Ristijärvi": { own: "Ristijärven", in: "Ristijärvellä" },
			"Rovaniemi": { own: "Rovaniemen", in: "Rovaniemellä" },
			"Ruokolahti": { own: "Ruokolahden", in: "Ruokolahdella" },
			"Ruovesi": { own: "Ruoveden", in: "Ruovedellä" },
			"Rusko": { own: "Ruskon", in: "Ruskossa" },
			"Rääkkylä": { own: "Rääkkylän", in: "Rääkkylässä" },
			"Saarijärvi": { own: "Saarijärven", in: "Saarijärvellä" },
			"Salla": { own: "Sallan", in: "Sallassa" },
			"Salo": { own: "Salon", in: "Salossa" },
			"Saltvik": { own: "Saltvikin", in: "Saltvikissa" },
			"Sastamala": { own: "Sastamalan", in: "Sastamalassa" },
			"Sauvo": { own: "Sauvon", in: "Sauvossa" },
			"Savitaipale": { own: "Savitaipaleen", in: "Savitaipaleella" },
			"Savonlinna": { own: "Savonlinnan", in: "Savonlinnassa" },
			"Savukoski": { own: "Savukosken", in: "Savukoskella" },
			"Seinäjoki": { own: "Seinäjoen", in: "Seinäjoella" },
			"Sievi": { own: "Sievin", in: "Sievissä" },
			"Siikainen": { own: "Siikaisten", in: "Siikaisilla" },
			"Siikajoki": { own: "Siikajoen", in: "Siikajoella" },
			"Siikalatva": { own: "Siikalatvan", in: "Siikalatvassa" },
			"Siilinjärvi": { own: "Siilinjärven", in: "Siilinjärvellä" },
			"Simo": { own: "Simon", in: "Simossa" },
			"Sipoo": { own: "Sipoon", in: "Sipoossa" },
			"Siuntio": { own: "Siuntion", in: "Siuntiossa" },
			"Sodankylä": { own: "Sodankylän", in: "Sodankylässä" },
			"Soini": { own: "Soinin", in: "Soinissa" },
			"Somero": { own: "Someron", in: "Somerossa" },
			"Sonkajärvi": { own: "Sonkajärven", in: "Sonkajärvellä" },
			"Sotkamo": { own: "Sotkamon", in: "Sotkamossa" },
			"Sottunga": { own: "Sottungan", in: "Sottungassa" },
			"Sulkava": { own: "Sulkavan", in: "Sulkavalla" },
			"Sund": { own: "Sundin", in: "Sundissa" },
			"Suomussalmi": { own: "Suomussalmen", in: "Suomussalmella" },
			"Suonenjoki": { own: "Suonenjoen", in: "Suonenjoella" },
			"Sysmä": { own: "Sysmän", in: "Sysmässä" },
			"Säkylä": { own: "Säkylän", in: "Säkylässä" },
			"Taipalsaari": { own: "Taipalsaaren", in: "Taipalsaaressa" },
			"Taivalkoski": { own: "Taivalkosken", in: "Taivalkoskella" },
			"Taivassalo": { own: "Taivassalon", in: "Taivassalossa" },
			"Tammela": { own: "Tammelan", in: "Tammelassa" },
			"Tampere": { own: "Tampereen", in: "Tampereella" },
			"Tervo": { own: "Tervon", in: "Tervossa" },
			"Tervola": { own: "Tervolan", in: "Tervolassa" },
			"Teuva": { own: "Teuvan", in: "Teuvalla" },
			"Tohmajärvi": { own: "Tohmajärven", in: "Tohmajärvellä" },
			"Toholampi": { own: "Toholammen", in: "Toholammella" },
			"Toivakka": { own: "Toivakan", in: "Toivakassa" },
			"Tornio": { own: "Tornion", in: "Torniossa" },
			"Turku": { own: "Turun", in: "Turussa" },
			"Tuusniemi": { own: "Tuusniemen", in: "Tuusniemessä" },
			"Tuusula": { own: "Tuusulan", in: "Tuusulassa" },
			"Tyrnävä": { own: "Tyrnävän", in: "Tyrnävällä" },
			"Ulvila": { own: "Ulvilan", in: "Ulvilassa" },
			"Urjala": { own: "Urjalan", in: "Urjalassa" },
			"Utajärvi": { own: "Utajärven", in: "Utajärvellä" },
			"Utsjoki": { own: "Utsjoen", in: "Utsjoella" },
			"Uurainen": { own: "Uuraisten", in: "Uuraisilla" },
			"Uusikaarlepyy": { own: "Uudenkaarlepyyn", in: "Uudessakaarlepyyssä" },
			"Uusikaupunki": { own: "Uudenkaupungin", in: "Uudessakaupungissa" },
			"Vaala": { own: "Vaalan", in: "Vaalassa" },
			"Vaasa": { own: "Vaasan", in: "Vaasassa" },
			"Valkeakoski": { own: "Valkeakosken", in: "Valkeakoskella" },
			"Valtimo": { own: "Valtimon", in: "Valtimossa" },
			"Vantaa": { own: "Vantaan", in: "Vantaalla" },
			"Varkaus": { own: "Varkauden", in: "Varkaudessa" },
			"Vehmaa": { own: "Vehmaan", in: "Vehmaalla" },
			"Vesanto": { own: "Vesannon", in: "Vesannolla" },
			"Vesilahti": { own: "Vesilahden", in: "Vesilahdella" },
			"Veteli": { own: "Vetelin", in: "Vetelissä" },
			"Vieremä": { own: "Vieremän", in: "Vieremällä" },
			"Vihti": { own: "Vihdin", in: "Vihdissä" },
			"Viitasaari": { own: "Viitasaaren", in: "Viitasaaressa" },
			"Vimpeli": { own: "Vimpelin", in: "Vimpelissä" },
			"Virolahti": { own: "Virolahden", in: "Vironlahdella" },
			"Virrat": { own: "Virtojen", in: "Virroilla" },
			"Vårdö": { own: "Vårdön", in: "Vårdössa" },
			"Vöyri": { own: "Vöyrin", in: "Vöyrissä" },
			"Ylitornio": { own: "Ylitornion", in: "Ylitorniossa" },
			"Ylivieska": { own: "Ylivieskan", in: "Ylivieskassa" },
			"Ylöjärvi": { own: "Ylöjärven", in: "Ylöjärvellä" },
			"Ypäjä": { own: "Ypäjän", in: "Ypäjällä" },
			"Ähtäri": { own: "Ähtärin", in: "Ähtärissä" },
			"Äänekoski": { own: "Äänekosken", in: "Äänekoskella" }
		};

		return function(city, type) {
			if (!city) {
				return;
			}
			if ((!type && city) || !cities[city]) {
				return city;
			}

			if (city && (type == "own" || type == "in") && cities[city]) {
				return cities[city][type];
			}
		};
	}

	angular.module("KimaMain").filter("cityConjugation", CityConjugationFilter);
})();